import {
  LineChart,
  BarChart3,
  TrendingUp,
  GraduationCap,
  DollarSign,
  Filter,
  Sparkles,
  Bot,
  Wand2,
  Eye,
  Grid3x3,
  CandlestickChart,
  FileText,
  Activity,
  User,
  Sigma,
  MessageCircle,
  type LucideIcon,
} from "lucide-react";

/**
 * Nav-item `icon` string (from Sidebar.tsx / mobileSideBar.tsx's shared
 * `items`/`bottomItems` data) -> Lucide icon component. Replaces the old
 * per-item `src/icons/{name}Icon.tsx` custom SVGs, which were sourced
 * ad hoc (mixed Heroicons-style outlines, older hardcoded-fill icons, at
 * least one lifted straight from svgrepo.com) and couldn't be recolored
 * from the outside — `Icon.tsx` never forwarded props down to them, so
 * hover/active states could only ever be done via a background swap,
 * never the icon itself. Lucide is already a project dependency and
 * already the icon convention in Financials/SingleStockAnalysis/Support
 * — no new package, and every icon here takes color via `currentColor`,
 * so a plain `className` on the rendered component is enough for
 * rest/hover/active theming.
 *
 * "ChatBubble" and "Support" used to be the same icon (Stock Chatbot and
 * Support shared one bubble); split into Bot / MessageCircle since
 * they're different concepts. "NineDots" (Equation Builder) is now
 * Sigma — a math symbol reads more accurately than an app-launcher grid
 * for that item.
 */
export const SIDEBAR_ICON_MAP: Record<string, LucideIcon> = {
  fundemantal: LineChart,
  bar: BarChart3,
  SingleStockAnalysis: TrendingUp,
  BeginnerAnalysis: GraduationCap,
  Dollar: DollarSign,
  clipboard: Filter,
  Screen: Sparkles,
  ChatBubble: Bot,
  Support: MessageCircle,
  StockAssistant: Wand2,
  Eye,
  Heatmap: Grid3x3,
  TechnicalAnalysis: CandlestickChart,
  DocumentText: FileText,
  Pulse: Activity,
  User,
  NineDots: Sigma,
};
